<!-- Banner Area -->
<div class="banner-area-three banner-bg">
    <div class="container">
        <div class="banner-content banner-content-three">
            <span>Since 2020</span>
            <h1>Good Planning Means Success In Business</h1>
            <p>Accurate financials and strategic planning for your business growth. Trust our expertise to navigate your
                success.</p>
            <div class="banner-btn">
                <a routerLink="/contact" class="contact-btn">Contact Us</a>
                <a routerLink="/contact" class="get-btn">Get A Quote</a>
            </div>
        </div>
    </div>
</div>
<!-- Banner Area End -->

<!-- Status Area -->
<div class="status-area">
    <div class="container status-bg">
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="status-card">
                    <h3>Accounting Services</h3>
                    <p>Outsource full accounting functions to streamline operations and focus on core business
                        activities, enhancing efficiency and productivity.</p>
                    <!-- <i class='flaticon-magnifying-glass'></i> -->
                    <div class="status-bottom-1"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="status-card">
                    <h3>Taxation Services</h3>
                    <p>Maximize your savings with our expert tax strategies. We ensure compliance while finding
                        opportunities to reduce your tax burden.</p>
                    <!-- <i class='flaticon-bank'></i> -->
                    <div class="status-bottom-2"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                <div class="status-card">
                    <h3>Business Solutions</h3>
                    <p>Achieve your business goals with our strategic financial planning. Our tailored solutions are
                        designed to drive your growth and success.</p>
                    <!-- <i class='flaticon-settings'></i> -->
                    <div class="status-bottom-3"></div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Status Area End -->

<!-- Services Area -->
<div class="services-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="section-title">
                    <span>Our Services</span>
                    <!-- <h2>Our Best Consulting Services Make You To Reach Your Goal</h2> -->
                    <h2>Expert Consulting for Business Success</h2>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="service-text">
                    <p>Experience unparalleled expertise with our comprehensive suite of services. From meticulous
                        financial analysis to strategic planning and tax optimization, we tailor our solutions to meet
                        your unique business needs. Trust us to enhance your financial health and guide your business
                        towards sustainable growth.</p>
                </div>
            </div>
        </div>

        <div class="row pb-20">
            <div class="col-lg-4 col-md-6">
                <div class="services-card services-card-bg">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-sort"></i></a>
                    <h3><a routerLink="/services-details">Bookkeeping</a></h3>
                    <p>Maintain accurate and up-to-date financial records to support informed decision-making and
                        business growth.</p>
                    <a routerLink="/services-details" class="services-more"><i
                            class='flaticon-double-right-arrows-angles'></i></a>
                    <div class="services-card-bottom"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-card services-card-bg">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-bank"></i></a>
                    <h3><a routerLink="/services-details">Financial Accounting</a></h3>
                    <p>Manage all aspects of financial accounting, ensuring precision and compliance with statutory
                        requirements.</p>
                    <a routerLink="/services-details" class="services-more"><i
                            class='flaticon-double-right-arrows-angles'></i></a>
                    <div class="services-card-bottom"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-card services-card-bg">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-analytics"></i></a>
                    <h3><a routerLink="/services-details">CIPC Services</a></h3>
                    <p>Comprehensive services for company registrations, annual returns, and compliance with CIPC
                        requirements.</p>
                    <a routerLink="/services-details" class="services-more"><i
                            class='flaticon-double-right-arrows-angles'></i></a>
                    <div class="services-card-bottom"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-card services-card-bg">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-chess-pieces"></i></a>
                    <h3><a routerLink="/services-details">Independent Review</a></h3>
                    <p>Conduct objective reviews of financial statements to ensure accuracy and compliance with
                        regulatory standards.</p>
                    <a routerLink="/services-details" class="services-more"><i
                            class='flaticon-double-right-arrows-angles'></i></a>
                    <div class="services-card-bottom"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-card services-card-bg">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-briefcase-1"></i></a>
                    <h3><a routerLink="/services-details">E-Filing</a></h3>
                    <p>File taxes electronically for faster processing and full compliance with all SARS requirements.
                    </p>
                    <a routerLink="/services-details" class="services-more"><i
                            class='flaticon-double-right-arrows-angles'></i></a>
                    <div class="services-card-bottom"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-card services-card-bg">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-people"></i></a>
                    <h3><a routerLink="/services-details">Payroll Services</a></h3>
                    <p>Efficient payroll processing including PAYE, UIF, SDL calculations, and payslip generation for
                        your employees.</p>
                    <a routerLink="/services-details" class="services-more"><i
                            class='flaticon-double-right-arrows-angles'></i></a>
                    <div class="services-card-bottom"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-card services-card-bg">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-briefcase"></i></a>
                    <h3><a routerLink="/services-details">Business Solutions</a></h3>
                    <p>Tailored business solutions to help you navigate challenges and achieve strategic goals
                        efficiently and effectively.</p>
                    <a routerLink="/services-details" class="services-more"><i
                            class='flaticon-double-right-arrows-angles'></i></a>
                    <div class="services-card-bottom"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-card services-card-bg">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-sort"></i></a>
                    <h3><a routerLink="/services-details">Tax Services</a></h3>
                    <p>Comprehensive tax services to ensure compliance and optimize your tax liabilities effectively.
                    </p>
                    <a routerLink="/services-details" class="services-more"><i
                            class='flaticon-double-right-arrows-angles'></i></a>
                    <div class="services-card-bottom"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="services-card services-card-bg">
                    <a routerLink="/services-details" class="services-icon"><i class="flaticon-medal"></i></a>
                    <h3><a routerLink="/services-details">VAT</a></h3>
                    <p>Manage VAT registration, returns, and payments to ensure compliance with South African tax laws.
                    </p>
                    <a routerLink="/services-details" class="services-more"><i
                            class='flaticon-double-right-arrows-angles'></i></a>
                    <div class="services-card-bottom"></div>
                </div>
            </div>
        </div>


        <div class="service-view-btn text-center">
            <a routerLink="/services" class="view-btn">View More</a>
        </div>
    </div>

    <div class="service-shape">
        <div class="shape1"><img src="assets/img/shape/shape6.png" alt="Images"></div>
        <div class="shape2"><img src="assets/img/shape/shape7.png" alt="Images"></div>
        <div class="shape3"><img src="assets/img/shape/shape8.png" alt="Images"></div>
    </div>
</div>
<!-- Services Area End -->

<!-- Video Area -->
<!-- <div class="video-area video-bg2">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-12">
                <div class="video-btn">
                    <a href="https://www.youtube.com/watch?v=07d2dXHYb94&t=11s" class="video-play-btn popup-btn"><i
                            class="flaticon-play-button"></i></a>
                </div>
            </div>

            <div class="col-lg-8 col-md-12">
                <div class="video-content">
                    <div class="section-title">
                        <span>Intro Video</span>
                        <h2>Explore Us Watch This Full Video and Know Us</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid mr-0 pr-0">
        <div class="guidelines-area guidelines-max guidelines-bg2">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <div class="guidelines-content">
                        <h2>A Proper Guideline Can Make Your Business Successful</h2>
                        <p>Proin magna felis, tincidunt eget lectus id, maximus ultricies eros. Aliquam eu lacus vitae
                            nulla faucibus mollis. Proin velit mi, molestie commodo neque laoreet a.Fusce cursus iaculis
                            elit vitae auctor. Mauris venenatis vestibulum eros, sed turpis molestie ac. Nunc convallis
                            nisi in maximus tincidunt.</p>
                        <div class="signature"><img src="assets/img/signature.png" alt="Images"></div>
                        <div class="content">
                            <h3>Smithy Karnes</h3>
                            <span>Founder & CEO</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- Video Area End -->

<!-- About Area -->
<div class="about-area pt-100 pb-70" id="about">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-12 pl-0">
                <div class="about-img-3">
                    <img src="assets/img/about/abouthome.png" alt="Images">
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="about-content about-content-max">
                    <span>About Us</span>
                    <h2>Your Trusted Accounting Partner
                    </h2>
                    <!-- <h2>We Are Standing With <b>30+</b> Years Of Experience</h2> -->
                    <!-- <h3>Your Trusted Accounting Partner</h3> -->
                    <p>With over 10 years of professional experience, our founder has built a reputation for trusted,
                        effective business consulting and accounting services. We provide personalized, strategic
                        solutions to help businesses thrive.</p>
                    <p>At My Professional Accountants, we pride ourselves on our client-centric approach, leveraging
                        extensive industry knowledge to guide businesses towards financial success. Our team has worked
                        with a diverse range of clients, including a major South African bank.</p>
                    <!-- <p>Our mission is to empower businesses with accurate financial insights and strategic advice,
                        ensuring compliance and optimizing financial performance.</p> -->

                    <!-- <div class="row">
                        <div class="col-lg-4 col-md-4 pr-0">
                            <div class="about-counter">
                                <i class="flaticon-medal"></i>
                                <div class="content">
                                    <h3>1200+</h3>
                                    <span>Award Winner</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-4 pr-0">
                            <div class="about-counter">
                                <i class="flaticon-team"></i>
                                <div class="content">
                                    <h3>30+</h3>
                                    <span>Years Experience</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-4 pr-0">
                            <div class="about-counter">
                                <i class="flaticon-briefcase"></i>
                                <div class="content">
                                    <h3>5000+</h3>
                                    <span>Business Guide</span>
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <div class="about-btn">
                        <a routerLink="/about" class="learn-btn">Learn More</a>
                        <a routerLink="/contact" class="get-btn">Get A Quote</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- About Area End -->

<!-- Guidelines Area -->
<div class="guidelines-area-two">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-12 pl-0">
                <div class="guidelines-img">
                    <img src="assets/img/homepagethirdimage2.png" alt="Images">
                </div>
            </div>

            <div class="col-lg-7 col-md-12 pr-0">
                <div class="guidelines-content-bg">
                    <div class="guidelines-content-two">
                        <h2>Empowering Businesses Through Strategic Guidance</h2>
                        <p>At My Professional Accountants, we believe in providing tailored solutions that foster growth
                            and success.
                            Our commitment is to empower businesses with accurate financial insights and strategic
                            advice,
                            ensuring compliance and optimizing financial performance.</p>
                        <!-- <div class="signature"><img src="assets/img/signature2.png" alt="Images"></div> -->
                        <div class="content">
                            <h3>Marium Majeed</h3>
                            <span>Founder & CEO</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Guidelines Area End -->

<!-- Choose Area -->
<div class="choose-area-two pt-100 pb-70">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-7 col-md-12 pl-0">
                <div class="choose-content choose-content-bg">
                    <div class="choose-max">
                        <div class="section-title">
                            <span>Why Choose Us</span>
                            <h2>Your Trusted Partner for Comprehensive Accounting Solutions</h2>
                            <p>At My Professional Accountants, we are dedicated to providing personalized and strategic
                                financial solutions tailored to your business needs. Our expertise spans across company
                                registration, bookkeeping, tax planning, and financial consulting. Trust us to guide
                                your business towards sustainable growth and success with our commitment to excellence
                                and integrity.</p>
                            <a routerLink="/contact" class="default-btn">Get A Quote</a>
                        </div>

                        <div class="row border-top">
                            <div class="col-lg-6 col-sm-6">
                                <div class="choose-content-list choose-content-list-color">
                                    <i class="flaticon-sort"></i>
                                    <div class="content">
                                        <h3>Fast Service</h3>
                                        <p>Quick and efficient service to meet your accounting needs promptly and
                                            accurately.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-sm-6">
                                <div class="choose-content-list choose-content-list-color">
                                    <i class="flaticon-briefcase"></i>
                                    <div class="content">
                                        <h3>Easy to Contact</h3>
                                        <p>Always available to address your queries and provide timely support and
                                            advice.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-sm-6">
                                <div class="choose-content-list choose-content-list-color">
                                    <i class="flaticon-analytics"></i>
                                    <div class="content">
                                        <h3>Business Planning</h3>
                                        <p>Strategic business planning to guide your company towards sustainable growth
                                            and success.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-sm-6">
                                <div class="choose-content-list choose-content-list-color">
                                    <i class="flaticon-chess-pieces"></i>
                                    <div class="content">
                                        <h3>Experienced Team</h3>
                                        <p>Highly skilled professionals with extensive experience to ensure top-notch
                                            financial management and consulting.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-5 col-md-12 pr-0">
                <div class="choose-img-3">
                    <img src="assets/img/choose/1240x1050.png" alt="Images">
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Choose Area End -->

<!-- Client Area -->
<div class="client-area-two ptb-100">
    <div class="container">
        <div class="section-title text-center">
            <span>Clients Review</span>
            <h2>Our Valued Clients Share Their Success Stories</h2>
            <p>At My Professional Accountants, we take pride in our clients' achievements. Our personalized and
                strategic financial solutions have empowered businesses to reach new heights. Hear directly from those
                who have experienced our commitment to excellence and integrity.</p>
        </div>

        <div class="client-slider owl-carousel owl-theme pt-45">
            <div class="client-card">
                <h3>Dilshad Patel</h3>
                <span>CEO Of Pink Hijabi</span>
                <ul>
                    <li>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                    </li>
                </ul>
                <p>The team at My Professional Accountants is always available, offering insightful financial advice
                    tailored to our business needs.</p>
                <i class="flaticon-quote client-card-quote"></i>
                <!-- <div class="client-card-img">
                    <img src="assets/img/client/client-img1.png" alt="Images">
                </div> -->
            </div>

            <div class="client-card">
                <h3>Arsalan Ahmed</h3>
                <span>CEO Of My Guy Online Shopping</span>
                <ul>
                    <li>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                    </li>
                </ul>
                <p>My Professional Accountants has transformed our financial management. Their expertise and support
                    have been invaluable to our growth.</p>
                <i class="flaticon-quote client-card-quote"></i>
                <!-- <div class="client-card-img">
                    <img src="assets/img/client/client-img4.png" alt="Images">
                </div> -->
            </div>

            <div class="client-card">
                <h3>Nazeera</h3>
                <span>Manager at Albaraka Bank</span>
                <ul>
                    <li>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                    </li>
                </ul>
                <p>Their strategic analysis, planning and attention to detail helped us navigate complex financial
                    challenges with
                    remarkable ease.</p>
                <i class="flaticon-quote client-card-quote"></i>
                <!-- <div class="client-card-img">
                    <img src="assets/img/client/client-img3.png" alt="Images">
                </div> -->
            </div>

            <div class="client-card">
                <h3>Zain Abedin</h3>
                <span>COO at Cape Candy</span>
                <ul>
                    <li>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                        <i class='bx bxs-star'></i>
                    </li>
                </ul>
                <p>Exceptional service and dedication! They have been instrumental in streamlining our accounting
                    processes and ensuring compliance.</p>
                <i class="flaticon-quote client-card-quote"></i>
                <!-- <div class="client-card-img">
                    <img src="assets/img/client/client-img3.png" alt="Images">
                </div> -->
            </div>
        </div>
    </div>
</div>
<!-- Client Area End -->

<!-- Leader Area -->
<div class="leader-area">
    <div class="container">
        <div class="leader-content">
            <div class="section-title text-center">
                <h2>Expand Your Reach and Lead Your Industry</h2>
                <p>Unlock your business potential with expert accounting services. Let us guide you to success.</p>
            </div>
        </div>
    </div>
</div>
<!-- Leader Area End -->

<!-- Contact Area -->
<div class="contact-area pb-100">
    <div class="container">
        <div class="contact-area-bg">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <div class="contact-form">
                        <div class="section-title text-center">
                            <h2>Request a Consultation</h2>
                            <p>Contact us today for a personalized consultation. Discover how we can elevate your
                                business.</p>
                        </div>

                        <form id="contactForm">
                            <div class="row">
                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <input type="text" name="name" id="name" class="form-control" required
                                            placeholder="Name">
                                    </div>
                                </div>

                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <input type="email" name="email" id="email" class="form-control" required
                                            placeholder="Email">
                                    </div>
                                </div>

                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <input type="text" name="phone_number" id="phone_number" required
                                            class="form-control" placeholder="Phone">
                                    </div>
                                </div>

                                <div class="col-lg-6 col-sm-6">
                                    <div class="form-group">
                                        <input type="text" name="msg_subject" id="msg_subject" class="form-control"
                                            required placeholder="Your Subject">
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <textarea name="message" class="form-control" id="message" cols="30" rows="8"
                                            required placeholder="Your Message"></textarea>
                                    </div>
                                </div>

                                <div class="col-lg-12 col-md-12 text-center">
                                    <button type="submit" class="default-btn">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Contact Area End -->